








import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GJgrowEventCreateConfirmViewValueCell',
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateConfirmViewValueCell extends Vue {
  @Prop() dataTestid: string;
  mounted() {}
}
